import { chakra, type ChakraComponent } from '@chakra-ui/react';
import { useEventImageSrc } from '@/hooks/useEventImageSrc';
import { DEFAULT_EVENT_IMAGE } from '@/constants/defaultImages';

type ImgProps = React.ComponentPropsWithoutRef<'img'>;

interface EventImageProps extends Omit<ImgProps, 'src'> {
  /** The raw `events.image` DB value — full legacy URL or bare storage path */
  stored: string | null | undefined;
  /** Any extra Chakra-style props */
  [key: string]: unknown;
}

const ChakraImg = chakra('img') as ChakraComponent<'img'>;

/**
 * Drop-in replacement for `<img src={event.image} />` / `<chakra.img src={event.image} />`.
 * Resolves private bucket images to a signed URL on mount and refreshes on tab focus.
 */
export function EventImage({ stored, alt = '', ...rest }: EventImageProps) {
  const src = useEventImageSrc(stored);

  return (
    <ChakraImg
      src={src}
      alt={alt}
      onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
        const target = e.target as HTMLImageElement;
        if (target.src !== DEFAULT_EVENT_IMAGE) target.src = DEFAULT_EVENT_IMAGE;
      }}
      {...rest}
    />
  );
}
